import { useState, useEffect } from 'react';

import { useMediaQuery } from '@vimeo/bokeh';

/**
 * This hook is a customized to detect device type at client side for Viewer Home page.
 * If a device support touch events and smaller than 768px, it will be considered as a mobile device.
 * NOTE: viewer context's isMobile is not reliable, because it is based on user agent. It's recommended to detect type at client side.
 */
export function useDeviceDetection() {
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallerThan768] = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    setIsMobile(isTouchDevice && isSmallerThan768);
  }, [isSmallerThan768]);

  return { isMobile };
}
